import { Routes } from "@angular/router";

/**
 * The only routes that exist on the public status domain: the status page at "/",
 * and every other URL goes back to it. No back-office route, guard or chunk is reachable.
 */
export const statusRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./public-page/status-page.component").then(
        (m) => m.StatusPageComponent,
      ),
  },
  { path: "**", redirectTo: "" },
];
